import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AuthAccessProvider } from '../core/core.auth';
import { UserContext, UserInfo, BaseComponent, TaskResponse, Task, DetailedTaskResponse, DetailedTask, TBGUfficio, TBGCliente, TBGMilestone, TBGComment } from '../core/core.component';
import { MessageProvider } from '../service/message.service';
import { TaskService } from '../service/task.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs/Subject';
import { SelectItem } from 'primeng/primeng';
import { Observable } from 'rxjs';
import { UserService } from '../service/user.service';

declare var $: any;

@Component({
    selector: 'app-task-selector',
    templateUrl: './task-selector.component.html',
    styleUrls: ['./task-selector.component.css']
})
export class TaskSelectorComponent extends BaseComponent implements OnInit, OnDestroy {
    @Input() multiple: boolean = false;
    @Input() taskId: number = 0;
    @Input() enableCreation: boolean = false;
    @Input() reset: Subject<any> = new Subject<any>();
    @Output() onSelect = new EventEmitter<Task[]>();
    @Output() onUnselect = new EventEmitter<Task>();
    @Input() taskAsSubject: Subject<number> = null;
    @Input() tasks: DetailedTask[] = [];
    @Input() decorated: boolean = false;
    userContext: UserContext;
    userInfo: UserInfo;
    itemSelected: SelectItem;
    itemsSelected: SelectItem[] = [];
    filterTasks: SelectItem[] = [];
    filteredTasks: SelectItem[] = [];
    distinctTasksId: number[] = [];
    completed: boolean = true;
    officeFilterEnabled: boolean = false;
    excludeOfficeFilterEnabled: boolean = false;

    subscriptions: Subscription[] = [];

    constructor(protected authAccess: AuthAccessProvider,
        protected router: Router,
        protected messageProvider: MessageProvider,
        private taskService: TaskService,
        private userService: UserService) {
        super(authAccess, router, messageProvider);
    }

    ngOnDestroy() {
        if (this.subscriptions != null) {
            for (let i = 0; i < this.subscriptions.length; ++i) {
                this.subscriptions[i].unsubscribe();
            }
        }
    }

    ngOnInit() {
        this.userContext = this.authAccess.getUserContext();
        if (this.userContext == null) {
            this.authAccess.invalidate();
        } else {
            this.userService.currentUserInfo(this.userContext.srmToken).subscribe(
                result => {
                    this.userInfo = result;
                    if (this.userInfo.ufficioBodyRental) {
                        this.officeFilterEnabled = true;
                    } else {
                        this.excludeOfficeFilterEnabled = true;
                    }
                },
                error => {
                    this.handleError(error);
                }
            );
            this.subscriptions[0] = this.reset.asObservable().subscribe(res => { this.itemSelected = null; });
            this.initFilterTasks(false);
            if (this.taskAsSubject != null && typeof (this.taskAsSubject) != 'undefined') {
                this.subscriptions[1] = this.taskAsSubject.asObservable().subscribe(
                    taskId => {
                        this.taskId = taskId;
                        this.initFilterTasks(true);
                    });
            }
        }
    }

    createNewTask() {
        this.openTaskDetailAsPlugin();
    }

    selectItem() {
        let tasks: Task[] = [];
        if (this.multiple == false) {
            let task = this.itemSelected.value;
            if (task.id != -1) {
                tasks.push(task);
            } else {
                this.openTaskDetailAsPlugin();
            }
        }
        else {
            for (let i = 0; i < this.itemsSelected.length; ++i) {
                let currentTask = this.itemsSelected[i].value;
                tasks.push(currentTask);
            }
        }
        this.onSelect.emit(tasks);
    }

    private openTaskDetailAsPlugin() {
        $("#srmTaskSelector").blur();
        this.itemSelected = null;
        this.taskService.openTaskDetailAsPlugin();
    }

    unselectItem(item) {
        if (this.multiple == true) {
            let tasks: Task[] = [];
            for (let i = 0; i < this.itemsSelected.length; ++i) {
                let currentTask = this.itemsSelected[i].value;
                if (item.value.id != currentTask.id) {
                    tasks.push(currentTask);
                }
            }
            this.onSelect.emit(tasks);
        }
    }

    loseFocus() {
        if (this.multiple == false) {
            if (this.itemSelected == null || typeof (this.itemSelected) == 'undefined' ||
                typeof (this.itemSelected.value) == 'undefined') {
                this.onSelect.emit(null);
            }
        }
    }

    private initFilterTasks(forceLoad: boolean) {
        if (forceLoad == true || this.tasks == null || typeof (this.tasks) == 'undefined' || this.tasks.length == 0) {
            this.completed = false;
            let obsRecents: Observable<DetailedTaskResponse> = this.taskService.getRecentTasks(this.userContext.srmToken, 0);
            let obsSearch: Observable<DetailedTaskResponse> = this.taskService.searchTask(this.userContext.srmToken, "", 0);

            Observable.forkJoin([obsRecents, obsSearch]).subscribe(
                results => {
                    console.log(results);
                    this.tasks = [];
                    let responseRecent: DetailedTaskResponse = results[0];
                    for (var i = 0; i < responseRecent.issues.length; ++i) {
                        var current: DetailedTask = responseRecent.issues[i];
                        current.listItemIcon = "glyphicon-time";
                        this.tasks.push(current);
                        this.addTaskItem(current, "glyphicon-time");
                    }
                    let responseSearch: DetailedTaskResponse = results[1];
                    for (var i = 0; i < responseSearch.issues.length; ++i) {
                        var current: DetailedTask = responseSearch.issues[i];
                        current.listItemIcon = "glyphicon-tags";
                        this.tasks.push(current);
                        this.addTaskItem(current, "glyphicon-tags");
                    }
                    this.taskService.refreshTasks(this.tasks);
                    this.completed = true;
                },
                error => {
                    this.handleError(error);
                }
            );
        } else {
            if (this.filterTasks.length != 0) { return; }

            for (let i = 0; i < this.tasks.length; ++i) {
                let currentTask: Task = this.tasks[i];
                this.addTaskItem(currentTask, currentTask.listItemIcon);
            }
        }
    }

    private addTaskItem(task: Task, iconType: string) {
        if (this.distinctTasksId.indexOf(task.id) < 0) {
            task.listItemIcon = iconType;
            let item = { label: task.issueNo + " - " + task.title, value: task };
            this.filterTasks.push(item);
            if (task.id == this.taskId) {
                this.itemSelected = item;
                this.selectItem();
            }
            this.distinctTasksId.push(task.id);
        }
    }

    filterTask(event) {
        this.filteredTasks = [];
        if (event.query == "...") {
            this.filterTasks.forEach((item) => {
                if (
                    this.officeFilterEnabled &&
                    (item.value.ufficiodicompetenza === undefined ||
                        !this.matchesOfficeFilter(item.value.ufficiodicompetenza._name))
                ) {
                    return;
                }
                if (this.excludeOfficeFilterEnabled && item.value.ufficiodicompetenza !== undefined) {
                    return;
                }
                this.filteredTasks.push(item);
            });
            return;
        }
        const searched = event.query.toLowerCase();

        for (let i = 0; i < this.filterTasks.length; i++) {
            let item = this.filterTasks[i];

            if (
                this.officeFilterEnabled &&
                (item.value.ufficiodicompetenza === undefined ||
                    !this.matchesOfficeFilter(item.value.ufficiodicompetenza._name))
            ) {
                continue;
            }
            if (this.excludeOfficeFilterEnabled && item.value.ufficiodicompetenza !== undefined) {
                continue;
            }

            let inTitle = item.label.toLowerCase().indexOf(searched) >= 0;
            let inUfficioCompetenza = item.value.ufficiodicompetenza !== undefined;
            if (inUfficioCompetenza) {
                let ufficio: TBGUfficio = item.value.ufficiodicompetenza;
                inUfficioCompetenza = ufficio._name.toLowerCase().indexOf(searched) >= 0;
            }
            let inRefOrder = item.value.reforder !== undefined;
            if (inRefOrder) {
                inRefOrder = item.value.reforder.toLowerCase().indexOf(searched) >= 0;
            }
            let inCliente = item.value.clientecse !== undefined;
            if (inCliente) {
                let cliente: TBGCliente = item.value.clientecse;
                inCliente = cliente._name.toLowerCase().indexOf(searched) >= 0;
            }
            let inDescription = item.value.description !== undefined;
            if (inDescription) {
                inDescription = item.value.description.toLowerCase().indexOf(searched) >= 0;
            }
            let inCategory = item.value.cateogry !== undefined;
            if (inCategory) {
                inCategory = item.value.category.toLowerCase().indexOf(searched) >= 0;
            }
            let inMilestone = item.value.milestone !== undefined;
            if (inMilestone) {
                let milestone: TBGMilestone = item.value.milestone;
                inMilestone = milestone.name != undefined && milestone.name.toLowerCase().indexOf(searched) >= 0;
            }
            let inComments = item.value.comments != undefined && item.value.comments.length > 0;
            if (inComments) {
                let comments: TBGComment[] = item.value.comments;
                let foundComment = false;
                comments.every(comment => {
                    if (comment.content.toLowerCase().indexOf(searched) >= 0) {
                        foundComment = true;
                        return false;
                    }
                    return true;
                });
                inComments = foundComment;
            }
            if (inTitle || inUfficioCompetenza || inRefOrder || inCliente || inDescription || inCategory || inMilestone || inComments) {
                this.filteredTasks.push(item);
            }
        }
        if (this.filteredTasks.length == 0 && this.enableCreation == true && this.multiple == false) {
            let creationTask = new Task();
            creationTask.id = -1;
            creationTask.listItemIcon = "glyphicon-plus";
            this.filteredTasks.push({ label: "Crea un nuovo task", value: creationTask });
        }
    }

    private matchesOfficeFilter(ufficio: string): boolean {
        const prefix = this.userInfo.ufficioBodyRental;
        if (prefix === "CHD") {
            return (
                ufficio.startsWith(prefix + " ") ||
                ufficio.startsWith("CLX2STRE") ||
                ufficio.startsWith("CLX2QUAD")
            );
        }
        return ufficio.startsWith(prefix + " ");
    }
}





// WEBPACK FOOTER //
// ./src/app/task-selector/task-selector.component.ts